export default { title: 'Încarcă recenzie Google' };
